import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class InvoiceSettingsService extends ApiService {
  namespace = "invoice-settings";
  icon = "WrenchWithScrewdriver";
  name = "message";
  favicon = "WrenchWithScrewdriver2";
  window = 290;
  Width = 690;
  DOMAIN = DOMAIN.INVOICE_SETTING;
  singular = this.terminology.invoice.singular;
  plural = this.terminology.invoice.plural;
  vowel = this.terminology.invoice.vowel;
  action = "action";

  constructor() {
    super("invoice-settings");
  }
}
